import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function SocialProofInitial() {
  const testimonials = [{
    name: 'Martín R.',
    role: 'Entrenador de Club',
    text: 'Organicé todo el año en una tarde. Nunca más improviso una sesión.'
  }, {
    name: 'Carolina S.',
    role: 'Entrenadora en Academia',
    text: 'Mis jugadores U13 mejoraron de nivel por primera vez en años. El sistema de progresión funciona.'
  }, {
    name: 'Diego V.',
    role: 'Entrenador Independiente',
    text: 'Antes tardaba 1 hora en armar una sesión táctica. Ahora abro el PDF y en 5 minutos tengo todo listo.'
  }];
  return <section className="py-16 px-4 bg-dark-DEFAULT" data-id="element-247">
      <div className="max-w-6xl mx-auto" data-id="element-248">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-249">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-dark-card border border-dark-border p-6 rounded-xl flex flex-col h-full" data-id="element-250">
              <div className="flex space-x-1 mb-4" data-id="element-251">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={18} className="text-brand-gold fill-brand-gold" data-id="element-252" />)}
              </div>
              <p className="text-text-secondary flex-grow mb-6 italic" data-id="element-253">
                "{testimonial.text}"
              </p>
              <div className="mt-auto" data-id="element-254">
                <p className="font-bold text-brand-DEFAULT" data-id="element-255">
                  {testimonial.name}
                </p>
                <p className="text-sm text-text-secondary" data-id="element-256">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}